<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <slot name="customHeader" />
          <h4 class="header-title mb-2">
            <span>{{ title }}</span>
          </h4>
          <p class="text-muted font-14">
            Total de <span>{{ tlsCases.length }}</span> tickets
          </p>

          <div
            v-if="tlsCases.length"
            class="row"
          >
            <div class="col-md-12">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  placeholder="Recherche un enregistrement..."
                />
              </b-input-group>
            </div>
          </div>

          <br>
          <b-table
            stacked="md"
            :items="tlsCases"
            :fields="fields"
            :filter="filter"
          >
            <template
              slot="remote_id"
              slot-scope="tlsCase"
            >
              <router-link
                class="font-weight-bold"
                :to="{ path: `/groups/${tlsCase.item.group_id}/cases/${tlsCase.item.id}` }"
              >
                {{ tlsCase.value }}
              </router-link>
            </template>

            <template
              slot="subject"
              slot-scope="tlsCase"
            >
              <span class="font-weight-bold">
                {{ tlsCase.value | truncate(80) }}
              </span>
            </template>

            <template
              slot="status"
              slot-scope="tlsCase"
            >
              <span
                v-if="tlsCase.item.status == 'open'"
                class="badge badge-danger text-white"
              >
                Nouveau
              </span>
              <span
                v-else-if="tlsCase.item.status == 'pending'"
                class="badge badge-warning text-white"
              >
                En attente
              </span>
              <span
                v-else-if="tlsCase.item.status == 'resolved'"
                class="badge badge-dark text-white"
              >
                Résolue
              </span>
            </template>

            <template
              slot="owner"
              slot-scope="tlsCase"
            >
              <span
                v-if="tlsCase.item.owner"
                class="badge badge-custom text-white"
              >
                {{ tlsCase.item.owner.firstname }}
                {{ tlsCase.item.owner.lastname }}
              </span>

              <span
                v-else
                class="badge badge-dark"
              >
                Aucune assignation
              </span>
            </template>

            <template
              slot="action"
              slot-scope="tlsCase"
            >
              <button
                v-if="tlsCase.item.status == 'pending'"
                type="button"
                class="close"
                aria-label="Close"
                @click="closeCase(tlsCase.item)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </template>
          </b-table>

          <p
            v-if="!tlsCases.length"
            class="mt-4 text-center"
          >
            <slot name="noCases">
              <b>Aucun ticket</b>
            </slot>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tls from "@/services/Tls";
const name = "TlsCasesList";

const fields = [
	{
		key: "remote_id",
		label: "ID",
		sortable: true
	},
	{
		key: "subject",
		label: "Sujet",
		sortable: true
	},
	{
		key: "status",
		label: "Status",
		sortable: true,
	},
	{
		key: "owner",
		label: "Assigné à",
		sortable: true,
		class: "text-right"
	},
	{
		key: "created_at",
		label: "Date de création",
		sortable: true,
		class: "text-right"
	},
	{
		key: "action",
		label: "",
		class: "text-right"
	}
];

const data = function () {
	return {
		filter: null,
		fields: [...fields]
	};
};

const humanizeStatus = function(status) {
	switch (status) {
	case "resolved":
		return "Résolue";
		break;

	case "open":
		return "Nouveau";
		break;
  
	case "pending":
		return "En attente";
		break;
  
	default:
		return "";
		break;
	}
};

const closeCase = function(tlsCase) {
	const { id: caseId, group_id: groupId } = tlsCase;

	Tls.Cases.close({ caseId, groupId })
		.then(_ => { this.$emit("removeCaseFromList", tlsCase); })
		.catch(error => {
			return Promise.reject(error);
		});
};

export default {
	name,
	props: {
		tlsCases: {
			type: Array,
			required: true
		},
		title: {
			type: String,
			default: "LISTE DES TICKETS"
		}
	},
	data,
	methods: {
		closeCase,
		humanizeStatus
	}
}; 
</script>
